module.exports = __webpack_public_path__ + "static/904-f95cfecb760813bbdedd9817b80b6784.png";